import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/purchase',
  component: layout,
  meta: {
    funcID: 'F0004',
    PID: 'F00'
  },
  children: ((pre) => [
    {
      path: 'pendingPlanFabric',
      name: `${pre}pendingPlanFabric`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000401',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/pendingPlanFabric')
    },
    {
      path: 'pendingPlanFabric/:pageType/:code',
      name: `${pre}pendingPlanFabric-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000401',
        PID: 'F00'
      },
      component: () =>
        import('@/views/factory/purchase/pendingPlanFabric/detail')
    },
    {
      path: 'pendingPlanMaterial',
      name: `${pre}pendingPlanMaterial`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000402',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/pendingPlanMaterial')
    },
    {
      path: 'pendingPlanMaterial/:pageType/:code?',
      name: `${pre}pendingPlanMaterial-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000402',
        PID: 'F00'
      },
      component: () =>
        import('@/views/factory/purchase/pendingPlanMaterial/detail')
    },
    {
      path: 'pendingPlanPackage',
      name: `${pre}pendingPlanPackage`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000403',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/pendingPlanPackage')
    },
    {
      path: 'pendingPlanPackage/:pageType/:code?',
      name: `${pre}pendingPlanPackage-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000403',
        PID: 'F00'
      },
      component: () =>
        import('@/views/factory/purchase/pendingPlanPackage/detail')
    },
    {
      path: 'fabricPurchase',
      name: `${pre}fabricPurchase`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000404',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/fabricPurchase')
    },
    {
      path: 'fabricPurchase/:pageType/:code?',
      name: `${pre}fabricPurchase-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { purchaseFabricNo = '' } = $route.query || {}
          return `面料采购单 | ${purchaseFabricNo || 'New'}`
        },
        funcID: 'F000404',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/fabricPurchase/detail')
    },
    {
      path: 'materialPurchase',
      name: `${pre}materialPurchase`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000405',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/materialPurchase')
    },
    {
      path: 'materialPurchase/:pageType/:code?',
      name: `${pre}materialPurchase-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { purchaseMaterialNo = '' } = $route.query || {}
          return `辅料采购单 | ${purchaseMaterialNo || 'New'}`
        },
        funcID: 'F000405',
        PID: 'F00'
      },
      component: () =>
        import('@/views/factory/purchase/materialPurchase/detail')
    },
    {
      path: 'packagePurchase',
      name: `${pre}packagePurchase`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000406',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/packagePurchase')
    },
    {
      path: 'packagePurchase/:pageType/:code?',
      name: `${pre}packagePurchase-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000406',
        PID: 'F00'
      },
      component: () => import('@/views/factory/purchase/packagePurchase/detail')
    }
  ])('purchase-')
}
